/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { AUTH_URLS } from '@/api/url';
import { AgencyPlan } from '@/types/enums';
import { isAxiosError } from 'axios';

export interface SignUpPayload {
  email: string;
  password: string;
  name: string;
  agency_name: string;
  verification_code: string;
  plan: AgencyPlan;
}

export interface SendVerificationCodePayload {
  email: string;
  name: string;
}

export interface LoginResponse {
  account: Account;
  access_token: string;
  access_token_expired_at: string;
  refresh_token: string;
  refresh_token_expired_at: string;
}

export interface AdminLoginPayload {
  email: string;
  password: string;
}

export interface ForgetPasswordPayload {
  email: string;
}

export interface ResetPasswordPayload {
  password: string;
}

export interface InvitationSignUpPayload {
  name: string;
  password: string;
}

export const apiSignUp = async (payload: SignUpPayload): Promise<ApiResponse<LoginResponse>> => {
  try {
    const res = await api.post<ApiResponse<LoginResponse>>(AUTH_URLS.SIGN_UP, payload);
    return res.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiSendVerificationCode = async (
  payload: SendVerificationCodePayload
): Promise<ApiResponse<void>> => {
  try {
    const res = await api.post<ApiResponse<void>>(AUTH_URLS.SEND_VERIFICATION_CODE, payload);
    return res.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiLogin = async (payload: AdminLoginPayload): Promise<ApiResponse<LoginResponse>> => {
  try {
    const res = await api.post<ApiResponse<LoginResponse>>(AUTH_URLS.LOGIN, payload);
    return res.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiForgetPassword = async (
  payload: ForgetPasswordPayload
): Promise<ApiResponse<void>> => {
  try {
    const res = await api.post<ApiResponse<void>>(AUTH_URLS.FORGET_PASSWORD, payload);
    return res.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiResetPassword = async (
  accessToken: string,
  payload: ResetPasswordPayload
): Promise<ApiResponse<void>> => {
  try {
    const res = await api.post<ApiResponse<void>>(AUTH_URLS.RESET_PASSWORD, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return res.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiInvitationSignUp = async (
  token: string,
  payload: InvitationSignUpPayload
): Promise<ApiResponse<LoginResponse>> => {
  try {
    const res = await api.post<ApiResponse<LoginResponse>>(AUTH_URLS.INVITATION_SIGN_UP, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
